import React from "react";
import { Button } from "react-bootstrap"; // Assuming you are using Bootstrap
import * as XLSX from "xlsx";
import download_icon from "../../Icons/download_icon.png";

const super_admin = localStorage.getItem("super_admin");
const isSuperAdmin = super_admin === "true" || super_admin === true;
const ExcelExport = ({ leadResponse }) => {
  const exportToExcel = () => {
    // Check if leadResponse is not undefined or empty
    if (!leadResponse || leadResponse.length === 0) {
      return;
    }

    const headers = [
      "Lead ID",
      "Lead Entry Date",
      "Lead last update date",
      "Follow up date",
      "Next Follow up date",
      "Relocation Date",
      "Total follow ups",
      "Lead Owner",
      "Service Type",
      "Lead Type",
      "Lead Source",
      "Status Name",
      "Open Lead Stage",
      "Closed Lead Stage",
      "Call Status",
      "Call Duration",
      "Department Name",
      "Description",
      "Relocation purpose",
      "From where",
      "First Name",
      "Last Name",
      "Gender",
      "Email",
      "Mobile no",
      "Alternate Number",
      "Pet Name",
      "Pet Type",
      "Pet Breed",
      "Pet Gender",
      "Pet Dob",
      "Pet Age",
      "No of Pets",
      "Pet Behaviour",
      "Pet Length",
      "Pet Height( D)",
      "Height (B)",
      "Pet Width",
      "Origin Country",
      "Origin State",
      "Origin City",
      "Origin Pin",
      "Destination Country",
      "Destination State",
      "Destination City",
      "Destination Pin",
      "Available Slot",
      "Mode of Transport",
      "Relocation Detail",
      "Pickup distance",
      "Drop Distance",
      "Container length",
      "Follow Up Remark",
      "Remark",
      "Sub Stage",
      "Region name",
    ];

    const data = leadResponse.map((item, index) => ({
      "Lead ID": item.lead_id,
      "Lead Entry Date": item.lead_entry_date,
      "Lead last update date": item.lead_last_update_date,
      "Follow up date": item.followup_date,
      "Next Follow up date":item.next_follow_up_date,
      "Relocation Date": item.relocation_date,
      "Total follow ups": item.total_followups,
      "Lead Owner": item.lead_owner,
      "Service Type": item.service_type,
      "Lead Type": item.lead_region,
      "Lead Source": item.leadsource,
      "Status Name": item.status_name,
      "Open Lead Stage": item.openLeadStage,
      "Closed Lead Stage": item.closedLeadStage,
      "Call Status": item.call_status,
      "Call Duration": item.call_duration,
      "Department Name": item.department_name,
      Description: item.description,
      "Relocation purpose": item.relocation_purpose,
      "From where": item.from_where,
      "First Name": item.first_name,
      "Last Name": item.last_name,
      Gender: item.gender,
      Email: item.email,
      "Mobile no": item.mobile_no,
      "Alternate Number": item.alternate_number,
      "Pet Name": item.pet_Name,
      "Pet Type": item.pet_type,
      "Pet Breed": item.pet_breed,
      "Pet Gender": item.pet_gender,
      "Pet Dob": item.pet_dob,
      "Pet Age": item.pet_age,
      "No of Pets": item.number_of_pets,
      "Pet Behaviour": item.pet_behaviour,
      "Pet Length": item.pet_length,
      "Pet Height( D)": item.pet_height,
      "Height (B)": item.container_length,
      "Pet Width": item.pet_width,
      "Origin Country": item.origin_country,
      "Origin State": item.origin_state,
      "Origin City": item.origin_city,
      "Origin Pin": item.origin_pin,
      "Destination Country": item.destination_country,
      "Destination State": item.destination_state,
      "Destination City": item.destination_city,
      "Destination Pin": item.destination_pin,
      "Available Slot": item.available_slot,
      "Mode of Transport": item.mode_of_transport,
      "Relocation Detail": item.relocation_detail,
      "Pickup distance": item.pick_up_distance,
      "Drop Distance": item.drop_distance,
      "Container length": item.container_length,
      "Follow Up Remark": item.subject,
      Remark: item.remark,
      "Sub Stage": item.substage_name,
      "Region name": item.region_name,
    }));

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data, { header: headers });

    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

    // Generate today's date in YYYYMMDD format
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10).replace(/-/g, "");

    // Save the Excel file with the new name
    const fileName = `LeadDataReport_${formattedDate}.xlsx`;
    XLSX.writeFile(workbook, fileName, { type: "array" });
  };

  return isSuperAdmin ? (
    <button
      onClick={exportToExcel}
      style={{
        height: "47px",
        border: "1px solid #C0C6CC",
        borderRadius: "7.5px",
        color: "#6A6A6A",
      }}
    >
      <img src={download_icon} alt="download" /> Download Excel
    </button>
  ) : null;
};

export default ExcelExport;
